var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7796",
    "data-name": "Group 7796",
    transform: "translate(-1356 -1228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    transform: "translate(1356 1228)",
    fill: "#f61130",
    stroke: "#f61130",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-dashboard",
    "data-name": "Icon material-dashboard",
    d: "M4.5,14.713h8.17V4.5H4.5Zm0,8.17h8.17V16.755H4.5Zm10.213,0h8.17V12.67h-8.17Zm0-18.383v6.128h8.17V4.5Z",
    transform: "translate(1365.309 1237.309)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircle);
export default __webpack_public_path__ + "static/media/red_circle.6fed2d6f958367a343a8f998b66a890b.svg";
export { ForwardRef as ReactComponent };